/**
 * Link editor class.
 *
 * @arg this.props.column {Object} Table column.
 * @arg this.props.column.name {string} Column name
 * @arg this.props.column.editor_default {*} Editor default value
 *
 * @arg this.props.row {Object} Row to edit, null if add, first if batch.
 * @arg this.props.add {bool} Is adding.
 * @arg this.props.batch {bool} Is batch editing.
 * @arg this.props.onEditorChanges {CTable#OnEditorChanges} Editor changes callback.
 *
 */


class CKaishiEditor extends Component {

    constructor() {
        super();

        this.onInputChange = this.onInputChange.bind(this);
        this.onResetClicked = this.onResetClicked.bind(this);
        this.onNullClicked = this.onNullClicked.bind(this);
        this.onOtherEditorChanged = this.onOtherEditorChanged.bind(this);
        this.onUndoClicked = this.onUndoClicked.bind(this);
        this.onToggleLink = this.onToggleLink.bind(this);

    }

    componentDidMount() {

        var self = this;

        this.setState({
            editor_value: (this.props.add || this.props.batch) ? this.props.column.editor_default : this.props.row[this.props.column.name],
                      editor_modified: false,
                      editor_valid: true,
                      options_history: clone(this.props.options[this.props.column.cell_link]),
                      options_current: clone(this.props.options[this.props.column.cell_link]),
                      weight_value: null
        });


        this.props.getOptionsForField(this.props.column.name, "").then(w => {
            var opt = {};
            w.rows.forEach(q => { opt[q[w.keys[0]]] = q[w.label]; });
            self.setState({options_current: opt, options_history: {...opt, ...self.state.options_history}});
        });

    }

    validateAndSend() {
        this.state.editor_valid = true;
        if(this.state.weight_value == null && this.state.editor_value != null && this.state.editor_value.includes("502"))
            this.state.editor_valid = false;

        this.sendChanges();
    }

    sendChanges(){
        if (this.props.row === null){
            this.props.onEditorChanges(this.props.column.name, true, this.state.editor_value, this.state.editor_valid);
        } else {
            this.props.onEditorChanges(this.props.column.name, this.state.editor_value != this.props.row[this.props.column.name], this.state.editor_value, this.state.editor_valid);
        }

    }

    onInputChange(e){
        this.setState({editor_value: e.target.value, editor_modified: true}, () => {this.validateAndSend()});
    }

    /**
     * Request to set value to NULL.
     *
     * @method
     * @listens CEditorFrame#cteditorreset
     */

    onResetClicked(){
        this.setState({editor_value: this.props.column.editor_default, editor_modified: true}, () => {this.validateAndSend()});
    }

    /**
     * Request to set value to Default
     *
     * @method
     * @listens CEditorFrame#cteditortonull
     */

    onNullClicked(){
        this.setState({editor_value: null, editor_modified: true}, () => {this.validateAndSend()});
    }

    /**
     * Request to set value to value at start editing.
     *
     * @method
     * @listens CEditorFrame#cteditorundo
     */

    onUndoClicked(){
        this.setState({editor_value: this.props.add ? this.props.column.editor_default : this.props.row[this.props.column.name] , editor_modified: false}, () => {this.validateAndSend()});
    }

    /**
     * Notifiaction for changes in some editor.
     *
     * @method
     * @listens CTable#cteditorchanged
     */

    onOtherEditorChanged(e){
         if(e.detail.initiator == "weight"){
             this.setState({weight_value: e.detail.changes.weight.value}, () => {this.validateAndSend()});
        }
    }


    onToggleLink(e){
        if(e.target.tagName == "LABEL") return;
        if(e.target.tagName == "DIV") return;
        var id = unwind_data(e, 'value');
        var kind = unwind_data(e, 'kind');
        var full = id+kind;


        var selectedids = [];

        if (this.state.editor_value !== undefined && this.state.editor_value !== null) {
            selectedids = this.state.editor_value.split(";").filter(x => {return x != "";});
        }

        if(selectedids.includes(id+'t') && kind == 't'){
            selectedids = selectedids.filter(x => x != full);
        } else if (selectedids.includes(id+'f') && kind == 'f'){
            selectedids = selectedids.filter(x => x != full);
        } else if (selectedids.includes(id+'t') && kind == 'f'){
            selectedids = selectedids.filter(x => x != (id+'t'));
            selectedids.push(full);
        } else if (selectedids.includes(id+'f') && kind == 't'){
            selectedids = selectedids.filter(x => x != (id+'f'));
            selectedids.push(full);
        } else {
            selectedids.push(full);
        }

        this.setState({editor_value: selectedids.join(";"), editor_modified: true}, () => {this.validateAndSend()});
    }


    render () {

        var self = this;

        var selectedids = [];

        if (self.state.editor_value !== undefined && self.state.editor_value !== null) {
            selectedids = self.state.editor_value.split(";").filter(x => {return x != "";});
        }

        var swhint = {};
        swhint["1"] = "16 или 20 форм, 32 формы (две дорожки)";
        swhint["2"] = "32 формы";
        swhint["3"] = "46 форм, гуидин, самосоставленные";
        swhint["4"] = "16 или 20 форм, 32 формы  (две дорожки)";
        swhint["5"] = "32 формы";
        swhint["6"] = "46 форм, гуидин, самосоставленные";
        swhint["7"] = "16 форм или 32 формы (две дорожки)";
        swhint["8"] = "32 формы";
        swhint["9"] = "46 форм, гуидин, самосоставленные";
        swhint["10"] = "16 форм или 32 формы (две дорожки)";
        swhint["11"] = "32 формы";
        swhint["12"] = "46 форм, гуидин, самосоставленные";
        swhint["13"] = "16 форм или 32 формы (две дорожки)";
        swhint["14"] = "32 формы";
        swhint["15"] = "46 форм, гуидин, самосоставленные";
        swhint["16"] = "16 форм или 32 формы (две дорожки)";
        swhint["17"] = "32 формы";
        swhint["18"] = "46 форм, гуидин, самосоставленные";
        swhint["19"] = "16 форм или 32 формы (две дорожки)";
        swhint["20"] = "32 формы";
        swhint["21"] = "46 форм, гуидин, самосоставленные";
        swhint["22"] = "16 форм или 32 формы (две дорожки)";
        swhint["23"] = "32 формы";
        swhint["24"] = "46 форм, гуидин, самосоставленные";
        swhint["50"] = "Цаилифо, Хэилунцюань, Тулунцюань, Наньцюань и т.д.";
        swhint["51"] = "Цаилифо, Хэилунцюань, Тулунцюань, Наньцюань и т.д.";
        swhint["52"] = "Шаолиньцюань, Лоханьцюань";
        swhint["53"] = "Шаолиньцюань, Лоханьцюань";
        swhint["54"] = "Ча-, Хуа-, Пао-, Минцзун цюань, Пигуа, Фаньцзыцюань";
        swhint["55"] = "Ча-, Хуа-, Пао-, Минцзун цюань, Пигуа, Фаньцзыцюань";
        swhint["56"] = "Богомол, Журавль, Орёл, Змея, Связанные руки, и др.";
        swhint["57"] = "Богомол, Журавль, Орёл, Змея, Связанные руки, и др.";
        swhint["58"] = "Багуа, Бацзи, Синъи";
        swhint["59"] = "Багуа, Бацзи, Синъи";
        swhint["100"] = "все виды дао, цзянь и др.";
        swhint["101"] = "все виды дао, цзянь и др.";
        swhint["102"] = "веер, тонфа и др.";
        swhint["103"] = "веер, тонфа и др.";
        swhint["104"] = "копьё, пудао, дадао и др.";
        swhint["105"] = "копьё, пудао, дадао и др.";
        swhint["106"] = "палка, посох и др.";
        swhint["107"] = "палка, посох и др.";
        swhint["108"] = "шэнбяо, цепь, кнут и др.";
        swhint["109"] = "шэнбяо, цепь, кнут и др.";
        swhint["110"] = "мечи, парные нунчаки, палки, топоры и др.";
        swhint["111"] = "мечи, парные нунчаки, палки, топоры и др.";
        swhint["112"] = "нунчаки, цеп, лавочка и др.";
        swhint["113"] = "нунчаки, цеп, лавочка и др.";
        swhint["150"] = "Тайцзи Дао, Тайцзи Цзянь и др.";
        swhint["151"] = "Тайцзи Дао, Тайцзи Цзянь и др.";
        swhint["152"] = "Тайцзи веер и др.";
        swhint["153"] = "Тайцзи веер и др.";
        swhint["154"] = "Длинное оружие, Ролибол, парные виды оружия Тайцзи и др.";
        swhint["155"] = "Длинное оружие, Ролибол, парные виды оружия Тайцзи и др.";

        var grpidx = [];
        grpidx.push("Спортивные стили, Чанцюань:");grpidx.push("");grpidx.push("");
        grpidx.push("Спортивные стили, Наньцюань:");grpidx.push("");grpidx.push("");
        grpidx.push("Спортивные стили, гунь:");grpidx.push("");grpidx.push("");
        grpidx.push("Спортивные стили, наньгунь:");grpidx.push("");grpidx.push("");
        grpidx.push("Спортивные стили, дао:");grpidx.push("");grpidx.push("");
        grpidx.push("Спортивные стили, наньдао:");grpidx.push("");grpidx.push("");
        grpidx.push("Спортивные стили, цян:");grpidx.push("");grpidx.push("");
        grpidx.push("Спортивные стили, цзянь:");grpidx.push("");grpidx.push("");
        grpidx.push("Традиционные стили, без оружия:");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");
        grpidx.push("Традиционные стили, с оружием:");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");grpidx.push("");
        grpidx.push("Дуйлянь:");grpidx.push("");grpidx.push("");
        grpidx.push("Групповые выступления:");
        grpidx.push("Прикладные виды:");grpidx.push("");


        return  <div class={cls("input", self.state.editor_valid ? "" : "is-danger")} style="width:100%;display:flex;flex-wrap:wrap;height:unset;" oncteditorchanged={self.onOtherEditorChanged}>
        {self.state.options_current ? Object.keys(self.state.options_current).map((x,i) => {
            if (parseInt(x) >= 200 && parseInt(x) < 300) return "";
            return <>{grpidx[i] != "" ? <div style="flex: 1 1 100%;" class="mt-1 mb-1"><span><b>{grpidx[i]}</b></span></div> : ""}
            <div class={cls("button mr-2 mb-2", selectedids.includes(x + "t") || selectedids.includes(x + "f") ? "is-info is-soft" : "")} style="flex-direction: column;" data-value={x} onClick={self.onToggleLink}>
            <div>{self.state.options_current[x]}<br/><small>{x in swhint ? swhint[x] : ""}</small></div>
            <div>
                {false ? <label class="checkbox"><input type="checkbox" data-kind="t" checked={selectedids.includes(x + "t")}/> Турнир</label> : ""}
                <label class="checkbox ml-1"><input type="checkbox" data-kind="f" checked={selectedids.includes(x + "f")}/> Фестиваль</label>
            </div>
            </div></>;
        }) : ""}
        </div>;
    }
}

ctable_register_class("CKaishiEditor", CKaishiEditor);


